import * as angular from 'angular';
import ngRoute from 'angular-route';
import 'angular-messages';
import 'angular-ui-bootstrap';
import 'angular-xeditable';

import confirm from './confirm/confirm-module';
import nvdbapi from './integration/nvdbapi/nvdbapi-module';
import menu from './presentation/menu/menu-module';
import routes from './routes';
import contract from './service/contract/contract-module';
import init from './service/init/init-module';
import messages from './service/messages/messages-module';
import security from './service/security/security-module';

import admin from './presentation/routes/admin/admin-module';
import contract3d from './presentation/routes/contract-3d/contract-3d-module';
import contractAssociation from './presentation/routes/contract-associations2/contract-associations-module';
import contractEvents from './presentation/routes/contract-eventlog/angular/contract-eventlog-module';
import contractExport from './presentation/routes/contract-export/contract-export-module';
import contractFeaturesOldReact from './presentation/routes/contract-feature-table-react/contract-feature-table-react-module';
import contractFeatures3 from './presentation/routes/contract-features-3/angular/contract-features-module';
import contractFiles from './presentation/routes/contract-files/contract-files-module';
import contracthome from './presentation/routes/contract-home/contract-home-module';
import Locational2 from './presentation/routes/contract-locational-2/angular/locational-2-module';
import Download from './presentation/routes/contract-download/angular/download-module';
import contractSettings from './presentation/routes/contract-settings/contract-settings-module';
import contractStatus from './presentation/routes/contract-status/contract-status-module';
import commentModals from './presentation/routes/comment-modal/comment-modal-controllers';
import contractlist2 from './presentation/routes/contractlist-2/angular/contractlist-2-module';
import newContract from './presentation/routes/newcontract/newcontract-module';
import user from './presentation/routes/user/user-module';
import appStatus from './presentation/status/appStatus-module';
import groupsAdmin from './presentation/routes/admin/groups/angular/groups-admin-module';
import loginHelp from "./presentation/routes/user-2/angular/login-help-module";
import changelog from "./presentation/routes/changelog/angular/changelog-module";

// Must manually load Leaflet plugins because they don't have any exports that we explicitly use
import "leaflet-draw";
import "leaflet.polylinemeasure";
import "leaflet-gps";
import "leaflet-easybutton";
import "leaflet.markercluster";

angular.module('dataforvalter.app', [
    require('angular-sanitize'),
    ngRoute,
    "ui.bootstrap",
    "xeditable",
    "ngMessages",
    init,
    security,
    contract,
    nvdbapi,
    menu,
    messages,
    confirm,
    appStatus,
    commentModals,
    contractlist2,
    contract3d,
    contracthome,
    newContract,
    contractFiles,
    contractFeaturesOldReact,
    contractFeatures3,
    contractSettings,
    contractStatus,
    contractExport,
    Locational2,
    Download,
    contractAssociation,
    contractEvents,
    admin,
    groupsAdmin,
    user,
    loginHelp,
    changelog
]).config(routes)
    .config(['$compileProvider', '$logProvider', '$provide',
        function($compileProvider: angular.ICompileProvider) {
            console.info('process.env.NODE_ENV: ' + process.env.NODE_ENV);

            if (process.env.NODE_ENV === 'production') {
                $compileProvider.debugInfoEnabled(false);
                $compileProvider.commentDirectivesEnabled(false);
                $compileProvider.cssClassDirectivesEnabled(false);
            }
        }])
    .directive('autofocus', [function() {
        return {
            require : 'ngModel',
            restrict: 'A',
            link(scope, element) {
                element[0].focus();
            }
        };
    }])
    .filter('orderObjectBy', function() {
        return function(items: any, field: string, reverse: boolean) {
            const filtered: any[] = [];
            angular.forEach(items, function(item) {
                filtered.push(item);
            });
            filtered.sort(function(a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });
            if (reverse) filtered.reverse();
            return filtered;
        };
    })
    .filter('array', function() {
        return function(items: any) {
            const filtered: any[] = [];
            angular.forEach(items, function(item) {
                filtered.push(item);
            });
            return filtered;
        };
    });
